import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="u62b1u6b49uff0cu60a8u8bbfu95eeu7684u9875u9762u4e0du5b58u5728"
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          u8fd4u56deu9996u9875
        </Button>
      }
    />
  );
};

export default NotFound;
